const trueIdentifyOption = [
  { label: '正确', value: 1 },
  { label: '不正确，请小妹手动修改登记', value: 0 }
];

const isApproveOption = [
  { label: '全部', value: '' },
  { label: '待审核', value: 0 },
  { label: '通过', value: 1 },
  { label: '不通过', value: 2 }
];

const isApproveMap: Record<string, string> = {
  0: '待审核',
  1: '通过',
  2: '不通过'
};

const DEFAULT_RISK_LEVEL = 'none';

const riskLevelOption = [
  { label: '无风险', value: 'none' },
  { label: '有风险', value: 'all' },
  { label: '高', value: 'high' },
  { label: '中', value: 'medium' },
  { label: '低', value: 'low' }
];

const riskLevelTagMap: Record<string, { label: string; bg: string; text: string }> = {
  high: { label: '高', bg: '#FFECE8', text: '#F53F3F' },
  medium: { label: '中', bg: '#FFF7E8', text: '#FF7D00' },
  low: { label: '低', bg: '#E8F3FF', text: '#165DFF' }
};
// 所有接口走同源前缀，开发由 setupProxy.js 转发，生产由 Nginx /inner-trans/ 转发
// const defaultBaseUrl = 'http://background-prod.fulibiji.com.cn/inner-trans';
const defaultBaseUrl = '/inner-trans';
const baseUrl = (process.env.REACT_APP_API_BASE_URL || defaultBaseUrl).replace(/\/$/, '');

// API 基础配置
const API_CONFIG = {
  // 基础地址（用于 API 请求）
  baseUrl: baseUrl,
  // 文件上传地址
  uploadUrl: baseUrl + '/common/uploadFile',
  videoTranscodeStatusUrl: '/common/videoTranscodeStatus',
  // 导出地址基础路径
  exportBaseUrl: baseUrl
};

/**
 * 手机号脱敏展示：保留前3后4位，中间以 * 替代。
 * 例：13812345678 -> 138****5678
 */
function maskPhone(phone?: string | null): string {
  if (phone == null || phone === '') return '-';
  const str = String(phone).trim();
  if (/^1\d{10}$/.test(str)) {
    return `${str.slice(0, 3)}****${str.slice(7)}`;
  }
  if (str.length >= 7) {
    return `${str.slice(0, 3)}****${str.slice(-4)}`;
  }
  return str;
}

export { trueIdentifyOption, isApproveMap, isApproveOption, DEFAULT_RISK_LEVEL, riskLevelOption, riskLevelTagMap, baseUrl, API_CONFIG, maskPhone };
